<template>
  <div class="my-4">

    
    <v-card class="" :loading='loading' :disabled='loading'>
      <v-card-text class="pt-0 pb-1">

        <v-row class="pb-0">
          <v-col cols="12" md="4" lg="3">
            <v-text-field outlined rounded dense hide-details placeholder='search' append-icon="mdi-magnify" class="mb-4" v-model="search" @change="searchUpdated" />
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="batches" item-key='xid'
          :server-items-length="batches_total"
          :options.sync="options"
          :footer-props="{ itemsPerPageOptions: [10, 20, 50] }"
          v-model='selection'
          show-expand single-expand :expanded.sync="expandedRows"
        >
          <template #item.created_at="{item,value}">
            <Moment :timestamp="value" mode="datetime" class="font-weight-medium" />
          </template>
          <template #item.jobs="{item}">
            {{item.jobs.length}}
          </template>

          <template #item.charges="{value}">{{formatCents(value)}}</template>
          <template #item.charges_discount="{value}">{{formatCents(value)}}</template>
          <template #item.subtotal="{value}">{{formatCents(value)}}</template>
          <template #item.tax="{item}">{{formatCents(item.tax)}}</template>

          <template #item._actions="{item}">
            <template v-if="item.ready">
              <v-menu>
                <template #activator="{on, attrs}">
                  <v-icon v-on='on' v-bind='attrs' color="primary" title="Export">mdi-download</v-icon>
                </template>
                <v-list dense>
                  <v-subheader>Download</v-subheader>
                  <v-list-item link  @click="batch_summary_pdf(item)">
                    <v-icon color="red" class="mr-4">mdi-file-document</v-icon>PDF Summary
                  </v-list-item>
                  <v-list-item link  @click="batch_summary_myob(item)">
                    <v-icon color="purple" class="mr-4">mdi-file-table</v-icon>MYOB AccountRight
                  </v-list-item>
                  <v-list-item link  @click="batch_summary_xero(item)">
                    <v-icon color="blue lighten-1" class="mr-4">mdi-file-table</v-icon>Xero
                  </v-list-item>
                  <v-list-item link  @click="batch_summary_xero2(item)">
                    <v-icon color="blue lighten-1" class="mr-4">mdi-file-table</v-icon>Xero v2
                  </v-list-item>
                  <v-list-item link  @click="batch_summary_zoho(item)">
                    <v-icon color="blue darken-2" class="mr-4">mdi-file-table</v-icon>Zoho Books
                  </v-list-item>
                  <v-list-item link  @click="batch_summary_csv(item)">
                    <v-icon color="green" class="mr-4">mdi-file-table</v-icon>Export CSV
                  </v-list-item>
                  <v-list-item link  @click="batch_zip(item)">
                    <v-icon color="orange" class="mr-4">mdi-folder-zip</v-icon>Zip Archive
                  </v-list-item>
                </v-list>
              </v-menu>
              
            </template>
            <v-chip v-else label small class="warning">Processing</v-chip>
          </template>
          <template v-slot:expanded-item="{ headers }">
            <td></td>
            <td :colspan="headers.length-1" class='pa-2'>
              <v-data-table
                :headers='invoiceHeaders'
                :items='filteredInvoices' :items-per-page='-1' item-key='xid'
                :loading='loading'
                hide-default-footer
                class='transparent'
              >
                <template #item.ref="{item,value}"><a @click='viewInvoice(item)' title='View Invoice'>{{value}}</a></template>
                <template #item.customer="{value}"><a @click='openCustomerInNewTab(value)' title='Open Customer in New Tab'>{{value.name}}</a></template>
                <template #item.location="{value}">
                  <span v-if="value" class="text-caption">
                    {{value.company_name}}<br/>
                    {{value.city_locality}}&nbsp;{{value.state_province}}&nbsp;{{value.postal_code}}
                  </span>
                </template>
                <template #item.charges="{value}">{{formatCents(value)}}</template>
                <template #item.charges_discount="{value}">{{formatCents(value)}}</template>
                <template #item.subtotal="{value}">{{formatCents(value)}}</template>
                <template #item.tax="{item}">{{formatCents(item.tax)}}</template>
                <template #item.total="{item}">{{formatCents(item.total)}}</template>
                <template #item._actions="{item}">
                  <v-menu>
                    <template #activator="{on, attrs}">
                      <v-btn fab small text v-on='on' v-bind='attrs'><v-icon color='secondary'>mdi-dots-horizontal</v-icon></v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item link @click="viewInvoice(item)">
                        <v-icon color='primary' class='mr-4'>mdi-open-in-new</v-icon>View Invoice
                      </v-list-item>
                      <v-list-item link @click="downloadInvoice(item)">
                        <v-icon color='primary' class='mr-4'>mdi-download</v-icon>Download Invoice
                      </v-list-item>
                      <v-divider />
                      <v-list-item link @click="revise(item)">
                        <v-icon color='warning' class='mr-4'>mdi-file-restore</v-icon>Revise Invoice
                      </v-list-item>
                      <v-divider />
                      <v-list-item link @click="resend(item)">
                        <v-icon color='warning' class='mr-4'>mdi-send</v-icon>Re-send Invoice
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>

      </v-card-text>
    </v-card>

  </div>
</template>

<style lang='scss' >
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import Moment from '@/components/Moment';
import MomentJS from 'moment';
import DownloadFile from 'downloadjs';

export default {
  name: 'Batches',

  components: {
    Moment,
  },

  data: () => ({
    loading: false,
    search: null,
    previousSearch: null,
    batches: [],
    batches_total: 0,
    options: { page: 1, itemsPerPage: 20 },
    invoices: [],
    selection: [],
    expandedRows: [],
    headers: [
      { text: 'Date / Time', value: 'created_at' },
      { text: 'No. of Invoices', value: 'invoice_count' },
      { text: 'Charges', value:'charges' },
      { text: 'Discounts', value:'charges_discount' },
      { text: 'Subtotal', value:'subtotal' },
      { text: 'Tax', value:'tax' },
      { text: 'Actions', value: '_actions' },
    ],
    invoiceHeaders: [
      { text: 'Invoice', value:'ref' },
      { text: 'Customer', value:'customer' },
      { text: 'Location', value:'location' },
      { text: 'Charges', value:'charges' },
      { text: 'Discounts', value:'charges_discount' },
      { text: 'Subtotal', value:'subtotal' },
      { text: 'Tax', value:'tax' },
      { text: 'Actions', value:'_actions' },
    ],
  }),

  computed: {
    ...mapGetters('Auth', ['LOGGED_IN']),
    expandedBatchId(){ return this.expandedRows?.[0]?.xid; },
    filteredInvoices(){
      if(!this.previousSearch) return this.invoices;
      return this.invoices.filter(inv => {
        let s = `${inv.ref} ${inv.customer.name} ${inv.location.company_name}`.toLowerCase();
        return s.includes(this.previousSearch.toLowerCase());
      });
    },
  },
  watch: {
    expandedBatchId(xid){ if(xid) { this.jobs = []; this.loadBatchInvoices(); } },
    'options.page'(){ this.loadBatches(); },
    'options.itemsPerPage'(){ this.loadBatches(); },
  },
  methods:{
    ...mapActions('API', ['API']),
    ...mapActions('PRINTING', ['PREVIEW']),
    ...mapActions('UI', ['CONFIRM', 'NOTIFY']),

    async loadBatches(){
      this.loading = true;
      this.batches = [];
      const paginate = await this.API({ method: 'POST', endpoint: 'billing/batches', data: {
        page: this.options.page,
        items_per_page: this.options.itemsPerPage,
        search: this.search
      }});
      this.batches = paginate.data;
      this.batches_total = paginate.total;
      this.loading = false;
    },

    searchUpdated(v){
      if(this.previousSearch != v) this.loadBatches();
      this.previousSearch = v;
    },

    async loadBatchInvoices(){
      this.loading = true;
      this.invoices = await this.API({ method: 'GET', endpoint: `billing/batches/${this.expandedBatchId}/invoices` });
      this.loading = false;
    },

    formatCents(cents){ return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },

    openCustomerInNewTab({xid}){ window.open(`#/customer/${xid}`, "_blank"); },

    async viewInvoice(invoice){
      this.loading = true;
      let invoice_pdf = await this.API({ method: 'GET', endpoint: `billing/invoices/${invoice.xid}/pdf` });
      this.PREVIEW(invoice_pdf);
      this.loading = false;
    },

    async downloadInvoice(invoice){
      window.open(`${window.app.config.api_base_url}/file/${invoice.pdf.xid}/${invoice.pdf.check_sha256}`, '_blank');
    },

    async revise(invoice){
      this.loading = true;
      await this.API({ method: 'DELETE', endpoint: `billing/batches/${this.expandedBatchId}/invoices/${invoice.xid}` });
      await Promise.all([this.loadBatches(), this.loadBatchInvoices()]);
      this.$emit('revise');
    },

    async resend(invoice){
      this.loading = true;
      await this.API({ method: 'POST', endpoint: `billing/batches/${this.expandedBatchId}/invoices/${invoice.xid}/resend` })
      .then(() => { this.NOTIFY({ message: `Invoice sent.` }); })
      .finally(() => { this.loading = false; });
    },

    refresh(){
      this.loadBatches();
    },

    async batch_summary_pdf(batch){
      let { xid, created_at } = batch;
      let pdf = await this.API({ method: 'GET', endpoint: `billing/batches/${xid}/export_pdf` });
      let date = MomentJS(created_at).format("YYYY-MM-DD HHmm");
      DownloadFile(new Blob([Uint8Array.from(atob(pdf), c => c.charCodeAt(0))]), `Invoices ${date}.pdf`);
    },

    async batch_summary_myob(batch){
      let { xid, created_at } = batch;
      let pdf = await this.API({ method: 'GET', endpoint: `billing/batches/${xid}/export_myob_accountright` });
      let date = MomentJS(created_at).format("YYYY-MM-DD HHmm");
      DownloadFile(new Blob([Uint8Array.from(atob(pdf), c => c.charCodeAt(0))]), `Invoices ${date} (myob).csv`);
    },

    async batch_summary_zoho(batch){
      let { xid, created_at } = batch;
      let pdf = await this.API({ method: 'GET', endpoint: `billing/batches/${xid}/export_zoho_books` });
      let date = MomentJS(created_at).format("YYYY-MM-DD HHmm");
      DownloadFile(new Blob([Uint8Array.from(atob(pdf), c => c.charCodeAt(0))]), `Invoices ${date} (zoho).csv`);
    },

    async batch_summary_csv(batch){
      //let { xid, created_at } = batch;
      let { xid } = batch;
      let download_key = await this.API({ method: 'GET', endpoint: `billing/batches/${xid}/export_csv` });
      let download_link = `billing/batches/${xid}/export_csv?key=${download_key}`;
      window.open(window.app.config.api_base_url + '/' + download_link, '_blank');

      //DownloadFile(new Blob([Uint8Array.from(atob(pdf), c => c.charCodeAt(0))]), `Invoices ${date}.csv`);
    },

    async batch_summary_xero(batch){
      let { xid, created_at } = batch;
      let pdf = await this.API({ method: 'GET', endpoint: `billing/batches/${xid}/export_xero` });
      let date = MomentJS(created_at).format("YYYY-MM-DD HHmm");
      DownloadFile(new Blob([Uint8Array.from(atob(pdf), c => c.charCodeAt(0))]), `Invoices ${date} (xero).csv`);
    },

    async batch_summary_xero2(batch){
      let { xid, created_at } = batch;
      let pdf = await this.API({ method: 'GET', endpoint: `billing/batches/${xid}/export_xero2` });
      let date = MomentJS(created_at).format("YYYY-MM-DD HHmm");
      DownloadFile(new Blob([Uint8Array.from(atob(pdf), c => c.charCodeAt(0))]), `Invoices ${date} (xero v2).csv`);
    },

    async batch_zip(batch){
      let { xid, created_at } = batch;
      let pdf = await this.API({ method: 'GET', endpoint: `billing/batches/${xid}/export_zip` });
      let date = MomentJS(created_at).format("YYYY-MM-DD HHmm");
      DownloadFile(new Blob([Uint8Array.from(atob(pdf), c => c.charCodeAt(0))]), `Invoices ${date}.zip`);
    }

  },

  mounted(){
    this.refresh();
  }

};
</script>
